import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "next/image";
import { useAppContext } from "../../../_context";

const TeamSuccess = () => {
  const [{ tx }] = useAppContext();

  return (
    <section className="team-success-section section-padding-top">
      <Container>
        <Row>
          <Col
            md={6}
            lg={7}
            className="d-flex align-items-center mb-4 mb-md-0 pe-lg-7">
            <Image src="/img/careers/team.jpg" width={780} height={780} />
          </Col>
          <Col md={6} lg={4} className="d-flex align-items-center mb-7 mb-md-0">
            <div>
              <div className="main-text">
                <h2 className="font-size-md-24 font-size-lg-40">
                  {tx["Our team is our success"]}
                </h2>
                <p className="text-grey-1 font-size-md-16 font-size-lg-24">
                  {
                    tx[
                      "At RacketPal we don’t believe in standing still. We want to change the world, one racket at a time."
                    ]
                  }
                </p>
              </div>
              <p>
                {
                  tx[
                    "We need fellow go-getters, sports lovers and brainstormers to help us get there. Our team is the magic ingredient for all the success we’ve had so far, and all the success we will have in the future."
                  ]
                }
              </p>
              <p className="mb-0">
                {
                  tx[
                    "And knowing that fact means we invest time and resources in making our team the happiest, most driven and satisfied team we can be."
                  ]
                }
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TeamSuccess;
